import { storage } from '@/services'

export default {
    methods: {
        isPermission(permission){
            const user          = storage.getUser()
            const permissions   = Object.keys(user.caps)
            if(!permissions.includes(permission)){
                return false
            }
            return true
        },
        isPermissions(list){
            const user          = storage.getUser()
            const permissions   = Object.keys(user.caps)
            let check           = list.split(',')
            if(!permissions.some(i => check.includes(i))){
                return false
            }
            return true
        },
    }
}
